<template>
  <div id="app">
    <router-view></router-view>
    <theme-picker />
  </div>
</template>

<script>
import backend from "./utils/backend";
import store from "./store";
import api from "./conf/api";
import ThemePicker from "@/components/ThemePicker";
import { set16ToRgb } from "@/utils/ruoyi";
export default {
  name: "App",
  components: { ThemePicker },
  data() {
    return {};
  },
  mounted() {
    this.$backend.request(this.$api.getWebSiteSetInfo, {}).then((res) => {
      if (res.code == 200) {
        document.title = res.data.name;
        const changeFavicon = (link) => {
          let $favicon = document.querySelector('link[rel="icon"]');
          if ($favicon !== null) {
            $favicon.href = link;
          } else {
            $favicon = document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            document.head.appendChild($favicon);
          }
        };
        changeFavicon(res.data.favicon); // 动态修改网站图标

        window.localStorage.setItem("logo", res.data.logo);
        window.localStorage.setItem("copyright", res.data.copyrightInformation);
        window.localStorage.setItem(
          "companyRegisterFlag",
          res.data.companyRegisterFlag
        );
      }
    });
    this.$backend.request(this.$api.getIndexColor, {}).then((res) => {
      document.documentElement.style.setProperty("--color-primary", res.msg);
      document.documentElement.style.setProperty(
        "--color-peiprimary",
        set16ToRgb(res.msg)
      );
      store.state.settings.theme = res.msg;
      localStorage.setItem(
        "layout-setting",
        `{
           "theme":"${res.msg}"
         }`
      );
    });
  },
  methods: {},
};
</script>

<style>
@import "./assets/styles/qingnio-ui.css";
@import "./assets/styles/font.less";
@import "./assets/styles/fontone.less";
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .el-pager li {
  background: #fff;
  border: rgba(221, 221, 221, 1) 1px solid;
  border-radius: 6px;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif !important;
}
body {
  margin: 0 auto !important;
  padding: 0 !important;
  background: #f4f4f4 !important;
  font-size: 14px !important;
  box-sizing: border-box;
  min-width: 1200px;
  font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif !important;
}
p {
  margin: 0px;
}
div {
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
textarea {
  font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif !important;
}
</style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue